<template>
    <div>
        <div class="juhL-prepare" v-if="prepareSession && prepareSession.sessionCode">
            <div class="juhL-tit fb">正在筹备</div>
            <h1 class="fb"><a :href="'/meeting_detail/'+prepareSession.sessionCode">{{prepareSession.name}}</a></h1>
            <template v-for="(m,i) in prepareSession.pc_extra_info">
                <p :key="i" v-if="m.type=='pre_time'"><span>预展时间：</span>
                    <template v-if="m.text.indexOf('已延期')!=-1">
                        {{m.text}}
                    </template>
                    <template v-else>{{m.picType}} - {{m.picUrl}}</template>
                </p>
            </template>
            <template v-for="(m,i) in prepareSession.pc_extra_info">
                <p :key="i" v-if="m.type=='preview_place'"><span>预展地点：</span>{{m.text}}</p>
            </template>
            <template v-for="(m,i) in prepareSession.pc_extra_info">
                <p :key="i" v-if="m.type=='special_num'"><span>专场个数：</span>{{m.text}}</p>
            </template>
            <template v-for="(m,i) in prepareSession.pc_extra_info">
                <p :key="i" v-if="m.type=='time'"><span>拍卖时间：</span>{{m.text}}</p>
            </template>
            <template v-for="(m,i) in prepareSession.pc_extra_info">
                <p :key="i" v-if="m.type=='auction_place'"><span>拍卖地点：</span>{{m.text}}</p>
            </template>
        </div>
        <div class="juhL-tab-con" v-if="preSession.sessionCode!=''&&preSession.sessionCode!=null || resultSession.sessionCode!=''&&resultSession.sessionCode!=null">
            <ul class="juhL-tab-ul">
                <li class="juhL-tab-li" v-if="preSession.sessionCode!=''" :class="{'curr':preShow}" @click="clickType(1)">拍卖预展</li>
                <li class="juhL-tab-li" v-if="resultSession.sessionCode!=''" :class="{'curr':resultShow}" @click="clickType(2)">拍卖结果</li>
                <li class="juhL-more" v-if="showMoreLink"><a :href="moreLink" id="moreresult">更多</a></li>
            </ul>
            <div class="juhL-tab-area" :style="{'display':preShow ? 'block' : 'none'}" v-if="preShow">
                <div class="juhL-tab-hd">
                    <h1 class="fb">
                        <router-link target="_blank" :to="{path:'/meeting_detail/'+preSession.sessionCode}">
                            {{preSession.name}}
                        </router-link>
                    </h1>
                    <p v-for="(item,i) in preSession.pc_extra_info" :key="i">
                      
                        <template v-if="item.type == 'pre_time' && item.text">
                            <span>{{item.label}}：</span>
                            <template v-if="item.text.indexOf('延期') != -1">{{item.text}}</template>
                            <template v-else>{{item.text}}</template>
                        </template>
                        <template v-if="item.type == 'preview_place' && item.text">
                            <span>{{item.label}}：</span>{{item.text}}
                        </template>
                    </p>
                    <p v-for="(item,i) in preSession.pc_extra_info" :key="i">
                       
                        <template v-if="item.type == 'time' && item.text">
                            <span>{{item.label}}：</span>{{item.text}}
                        </template>
                        <template v-else-if="item.type == 'auction_place' && item.text">
                            <span>{{item.label}}：</span>{{item.text}}
                        </template>
                    </p>
                    <p v-for="(item,i) in preSession.pc_extra_info" :key="i">
                        <template v-if="item.type == 'special_num' && item.text">
                            <span>{{item.label}}：</span>{{item.text}}
                        </template>
                        <template v-else-if="item.type == 'auction_total' && item.text">
                            <span>{{item.label}}：</span>{{item.text}}
                        </template>
                        <template v-else-if="item.type == 'success_total' && item.text">
                            <span>{{item.label}}：</span>{{item.text}}
                        </template>
                    </p>
                </div>
                <div class="juhL-sub-tit"><span class="fb fl">包含专场({{preSession.specialsList && preSession.specialsList.length}})</span></div>
                <div class="juhL-session">
                    <ul class="session-ul clearfix">
                        <li class="session-item" v-for="(item,i) in preSession.specialsList" :key="i">
                            <h1>
                                <router-link target="_blank" :to="{path:'/special_detail/'+item.specialCode}" >
                                    {{item.name}}
                                </router-link>
                                <div class="flag" v-if="item.live_info && item.live_info.have_live > 0 && item.live_info.label_list.length">
                                    <template v-for="(flag,n) in item.live_info.label_list">
                                        <img src="../../../assets/imgs/icon_videoLive.png" :key="n" title="视频直播" alt="视频直播" v-if="flag.name == '视频直播'">
                                        <img src="../../../assets/imgs/icon_tbp.png" :key="n" alt="同步拍" title="同步拍" v-else-if="flag.name == '同步拍'">
                                        <img src="../../../assets/imgs/icon_imgLive.png" :key="n" alt="图文直播" title="图文直播" v-else-if="flag.name == '图文直播'">
                                    </template>
                                </div>
                            </h1>
                            <template v-for="(con,k) in item.pc_extra_info">
                                <p :key="k" v-if="con.type == 'total' && con.text"><em>拍卖总数：</em>{{con.text}}</p>
                            </template>
                            <template v-for="(con,k) in item.extraInfo">
                                <p :key="k" v-if="con.label == '拍卖时间' && con.text"><em>拍卖时间：</em>{{con.text}}</p>
                            </template>
                            <template v-for="(con,k) in item.extraInfo">
                                <p :key="k" v-if="con.label == '地点' && con.text"><em>拍卖地点：</em>{{con.text}}</p>
                            </template>
                            <a :href="'/special_detail/'+item.specialCode" target="_blank" class="view-works">快速浏览专场</a>
                        </li>
                    </ul>

                </div>
                <div class="juhL-sub-tit">
                    <span class="fb fl">预展精品</span>
                    <span class="fl juhL-search">
    						<label class="fb" >LOT:</label>
    						<input type="text" name="lot" class="juhL-txt" v-model="lotVal">
    						<input type="button" class="juhL-btn" value="搜索" @click="gotoSpecial(preSession.sessionCode)" style="cursor:pointer;">
    				</span>
                    <span class="fr"><a :href="'/meeting_detail/'+preSession.sessionCode" target="_blank" >更多</a></span></div>
                <div class="juhL-result">
                    <ul class="juhL-result-ul clearfix" v-if="preAuctionArt.length">
                        <li v-for="(item,i) in preAuctionArt" :key="i">
                            <router-link :to="{path:'/paimai-'+item.artCode}" target="_blank"  class="juhL-link" :title="item.show_title">
                                <b><img :src="item.coverPic" :alt="item.show_title" :title="item.show_title"></b>
                            </router-link>
                            <dl class="juhL-info">
                                <dt class="fb">
                                    <router-link :to="{path:'/paimai-'+item.artCode}" target="_blank"  :title="item.show_title">{{item.show_title}}</router-link>
                                    <div class="flagLabel">
                                        <template v-if="item.live_info.label_list">
                                            <template v-for="(flag,n) in item.live_info.label_list">
                                                <span :key="n" v-if="flag.name == '视频直播'" title="视频直播"><img src="../../../assets/imgs/icon_videoLive.png"></span>
                                                <span :key="n" v-else-if="flag.name == '图文直播'" title="图文直播"><img src="../../../assets/imgs/icon_imgLive.png"></span>
                                                <span :key="n" v-else-if="flag.name == '同步拍'" title="同步拍"><img src="../../../assets/imgs/icon_tbp.png"></span>
                                            </template>
                                        </template>
                                    </div>
                                </dt>
                                <template v-for="(con,i) in item.pc_extra_info">
                                    <dd :key="i" v-if="con.label == 'lot号'">LOT号：{{con.text}}</dd>
                                </template>
                                <template v-for="(con,i) in item.pc_extra_info">
                                    <dd :key="i" v-if="con.type == 'gujia'">估价：{{con.smallText}}{{con.text}}</dd>
                                </template>
                                <template v-for="(con,i) in item.pc_extra_info">
                                    <dd :key="i" v-if="con.label == '拍卖时间'">日期：{{con.text}}</dd>
                                </template>
                            </dl>
                            <a :href="'/paimai-'+item.artCode" target="_blank"  class="juhL-de">点击查看详情</a>
                        </li>
                    </ul>
                    <emptyPage v-else></emptyPage>
                </div>
            </div>
            <div class="juhL-tab-area" :style="{'display':resultShow ? 'block' : 'none'}" v-if="resultShow">
                <div class="juhL-tab-hd">
                    <h1 class="fb">
                        <router-link target="_blank" :to="{path:'/meeting_detail/'+resultSession.sessionCode}">
                            {{resultSession.name}}
                        </router-link>
                    </h1>
                    <p v-for="(item,i) in resultSession.pc_extra_info" :key="i">
                        <template v-if="item.type == 'time' && item.text">
                            <span>{{item.label}}：</span>{{item.text}}
                        </template>
                        <template v-else-if="item.type == 'city' && item.text">
                            <span>{{item.label}}：</span>{{item.text}}
                        </template>
                        <template v-else-if="item.type == 'special_num' && item.text">
                            <span>{{item.label}}：</span>{{item.text}}
                        </template>
                    </p>
                    <p v-for="(item,i) in resultSession.pc_extra_info" :key="i">
                        <template v-if="item.type == 'ratio' && item.text">
                            <template v-if="isLogin">

                            <span>{{item.label}}：</span>{{item.text}}
                            </template>
                            <template v-else>
                                <span>{{item.label}}：</span><a href="javascript:;" @click="gotoLogin">请登录后查看</a>
                            </template>
                        </template>
                    </p>
                    <p v-for="(item,i) in resultSession.pc_extra_info" :key="i">
                        <template v-if="item.type == 'price' && item.text">
                            <template v-if="isLogin">

                                <span>{{item.label}}：</span>{{item.text}}
                            </template>
                            <template v-else>
                                <span>{{item.label}}：</span><a href="javascript:;" @click="gotoLogin">请登录后查看</a>
                            </template>
                        </template>
                    </p>
                </div>
                <div class="juhL-sub-tit"><span class="fb fl">包含专场({{resultSession.specialsList && resultSession.specialsList.length}})</span></div>
                <div class="juhL-session">
                    <ul class="session-ul clearfix">
                        <li class="session-item" v-for="(item,i) in resultSession.specialsList" :key="i">
                            <h1>
                                <router-link target="_blank" :to="{path:'/special_detail/'+item.specialCode}" >
                                    {{item.name}}
                                </router-link>
                                <div class="flag" v-if="item.live_info && item.live_info.have_live > 0 && item.live_info.label_list.length">
                                    <template v-for="(flag,n) in item.live_info.label_list">
                                        <img src="../../../assets/imgs/icon_videoLive.png" :key="n" title="视频直播" alt="视频直播" v-if="flag.name == '视频直播'">
                                        <img src="../../../assets/imgs/icon_tbp.png" :key="n" alt="同步拍" title="同步拍" v-else-if="flag.name == '同步拍'">
                                        <img src="../../../assets/imgs/icon_imgLive.png" :key="n" alt="图文直播" title="图文直播" v-else-if="flag.name == '图文直播'">
                                    </template>
                                </div>
                            </h1>

                            <template v-for="(con,k) in item.pc_extra_info">
                                <p :key="k" v-if="con.type == 'total' && con.text"><em>拍卖总数：</em>{{con.text}}</p>
                            </template>
                            <template v-for="(con,k) in item.extraInfo">
                                <p :key="k" v-if="con.label == '拍卖时间' && con.text"><em>拍卖时间：</em>{{con.text}}</p>
                                <p :key="k" v-if="con.label == '地点' && con.text"><em>拍卖地点：</em>{{con.text}}</p>
                            </template>
                            <template v-for="(con,k) in item.pc_extra_info">
                                <p :key="k" v-if="con.type == 'total_price' && con.text">
                                    <template v-if="isLogin">
                                        <em>成交总数：</em>{{con.text}}
                                    </template>
                                    <template v-else>
                                        <em>成交总数：</em><a href="javascript:;" @click="gotoLogin">请登录后查看</a>
                                    </template>
                                </p>
                                <p :key="k" v-if="con.label == '成交率' && con.text">
                                    <template v-if="isLogin">
                                        <em>成交率：</em>{{con.text}}
                                    </template>
                                    <template v-else>
                                        <em>成交率：</em><a href="javascript:;" @click="gotoLogin">请登录后查看</a>
                                    </template>
                                </p>
                            </template>
                            <a :href="'/special_detail/'+item.specialCode" target="_blank"  class="view-works">快速浏览专场</a>
                        </li>
                    </ul>
                </div>
                <div class="juhL-sub-tit">
                    <span class="fb fl">成交精品</span>
                    <span class="fl juhL-search">
    						<label class="fb">LOT:</label>
    						<input type="text" name="lot" class="juhL-txt" v-model="lotVal">
    						<input type="button" class="juhL-btn" value="搜索" @click="gotoSpecial(resultSession.sessionCode)" style="cursor:pointer;">
    				</span>
                    <span class="fr"><a :href="'/meeting_detail/'+resultSession.sessionCode" target="_blank" >更多</a></span></div>
                <div class="juhL-result" v-if="resultAuctionArt.length">
                    <ul class="juhL-result-ul clearfix">
                        <li v-for="(item,i) in resultAuctionArt" :key="i">
                            <router-link :to="{path:'/paimai-'+item.artCode}" target="_blank" class="juhL-link" :title="item.show_title">
                                <b><img :src="item.coverPic" :alt="item.show_title" :title="item.show_title"></b>
                            </router-link>
                            <dl class="juhL-info">
                                <dt class="fb">
                                    <router-link :to="{path:'/paimai-'+item.artCode}" target="_blank" :title="item.show_title">{{item.show_title}}</router-link>
                                    <div class="flagLabel">
                                        <template v-if="item.live_info.label_list">
                                            <template v-for="(flag,n) in item.live_info.label_list">
                                                <span :key="n" v-if="flag.name == '视频直播'" title="视频直播"><img src="../../../assets/imgs/icon_videoLive.png"></span>
                                                <span :key="n" v-else-if="flag.name == '图文直播'" title="图文直播"><img src="../../../assets/imgs/icon_imgLive.png"></span>
                                                <span :key="n" v-else-if="flag.name == '同步拍'" title="同步拍"><img src="../../../assets/imgs/icon_tbp.png"></span>
                                            </template>
                                        </template>
                                    </div>
                                </dt>
                                <template v-for="(con,i) in item.pc_extra_info">
                                    <dd :key="i" v-if="con.label == 'lot号'">LOT号：{{con.text}}</dd>
                                </template>
                                <template v-for="(con,i) in item.pc_extra_info">
                                    <dd :key="i" v-if="con.type == 'gujia'">估价：{{con.smallText}}{{con.text}}</dd>
                                </template>
                                <template v-for="(con,i) in item.pc_extra_info">
                                    <dd :key="i" v-if="con.label == '拍卖时间'">日期：{{con.text}}</dd>
                                </template>
                            </dl>
                            <router-link :to="{path:'/paimai-'+item.artCode}" target="_blank" class="juhL-de">点击查看详情</router-link>
                        </li>
                    </ul>
                </div>
                <emptyPage v-else></emptyPage>
            </div>
        </div>
        <el-dialog
            title="提示"
            :visible="showPop"
            width="30%"
            center>
            <span>{{msgTips}}</span>
            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closePop">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import emptyPage from "@/components/common/emptyPage";
import {gotoSpec} from "@/api/spec";

export default {
    name: "OrgSpecail",
    props:{
        isLogin:{
            type:Number
        },
        organName:{
            type:String
        },
        orgInfo:{
            type:Object
        },
        t:{
            type:Number
        },
        //机构详情（/v3/organ/other/info 的 data）。由父级 org_detail.vue 请求后下发，
        //本组件不再自己发请求 —— 父子各发一次会把同一份数据请求两遍。
        detail:{
            type:Object,
            default(){
                return {}
            }
        }
    },
    data(){
        return{
            dataJSON:{},
            lotVal:'',
            preSessionDisplay:false,
            resultSessionDisplay:false,
            // sessionCode:this.orgId,
            sessionText:'',
            resultShow:false,
            preShow:false,
            showPop:false,
            msgTips:'',
            params:{
                status:0,
                page:Number(this.$route.query.page) || 1,
                orderby:Number(this.$route.query.orderby) || 7,
                evaluation_price:Number(this.$route.query.evaluation_price) || 0,
                advancedSeach:Number(this.$route.query.advancedSeach) || 0,
                startTime:this.$route.query.startTime || '',
                endTime:this.$route.query.endTime || '',
                rmbPriceStart:Number(this.$route.query.rmbPriceStart) || 0,
                rmbPriceEnd:Number(this.$route.query.rmbPriceEnd) || 0,
                classCode:this.$route.query.classCode || '',
                organCode:this.orgId || '',
                item:Number(this.$route.query.item) || 0,
                is_total:1
            },
            moreLink:'',
            goodResultArt:[],
            status:0,
            resultSession:{},
            preSession:{},
            preAuctionArt:[],
            resultAuctionArt:[],
            spePreList:[],
            speResultList:[],
            prepareSession:{}
        }
    },
    computed:{
        ifLogin(){
            return this.isLogin || 0
        },
        // 「更多」入口只对 A/B/C 级机构开放（Grade 来自 /v1/organ/simple/info，
        // 实测是单个大写字母，如 A/B/C/D/E）。
        // 原条件是 Grade!='H'（黑名单），除 H 外全部放行，像 JG9516(D) 这类也会显示；
        // 改成白名单，非 A/B/C 一律隐藏。orgInfo 首帧是 {}，Grade 为 undefined 时同样隐藏。
        showMoreLink(){
            var grade = String((this.orgInfo && this.orgInfo.Grade) || '').trim().toUpperCase()
            return grade === 'A' || grade === 'B' || grade === 'C'
        },
    },
    //父级拿到详情后下发。immediate 是必须的：父级的请求可能比本组件 mounted 更早回来
    //（首帧就已经有值），只监听后续变化会漏掉那一次。
    watch:{
        detail:{
            immediate:true,
            handler(json){
                this.applyDetail(json)
            }
        }
    },
    methods:{
        clickType(num){
            switch (num){
                case 1:
                    this.preShow = true
                    this.resultShow = false
                    this.moreLink = '/preauction?status=0&page=1&evaluation_price=&advancedSeach=&start_time=&end_time=&rmbPriceStart=&rmbPriceEnd=&organ_code='+this.$route.params.id+'&citys=&organName='+this.organName+'&item=&is_total=1&keyword='
                    this.lotVal = ''
                    break
                case 2:
                    this.resultShow = true
                    this.preShow = false
                    this.moreLink = '/result?status=1&page=1&evaluation_price=&advancedSeach=&start_time=&end_time=&rmbPriceStart=&rmbPriceEnd=&organ_code='+this.$route.params.id+'&citys=&organName='+this.organName+'&item=&is_total=1&keyword='
                    this.lotVal = ''
                    break
            }
        },
        closePop(){
            this.lotVal = ''
            this.msgTips = ''
            this.showPop = false
        },
        gotoSpecial(code){
            let params = {
                showType:1,
                keyword:this.lotVal,
                session_code:code
            }
            gotoSpec(params).then((res) => {
                if(res.code == 0){
                    if(res.data.list == null){
                        this.showPop = true
                        this.msgTips = '没有搜索到相关拍品，请重新输入'
                        this.inputLog = ''
                    }else{
                        let speCode = res.data.list[0].SpecialCode
                        this.$router.push({
                            name:'special_detail',
                            params:{
                                id:speCode,
                            },
                            query:{
                                lot:this.lotVal
                            }
                        })
                    }
                }
            })
        },
        //只做数据落地，不再发请求。请求在父级 org_detail.vue 的 getOrgDetailFun() 里，
        //结果通过 detail prop 下发。
        applyDetail(json){
            if(!json || !Object.keys(json).length) return
            let resultSession = json.result_session || {}
            let preSession = json.pre_session || {}
            this.dataJSON = json
            this.status = json.status
            this.params.status = json.status
            this.goodResultArt = json.good_result_art
            this.resultSession = resultSession
            this.preSession = preSession
            this.resultAuctionArt = json.result_auction_art
            this.preAuctionArt = json.pre_auction_art
            this.prepareSession = json.prepare_session
            this.speResultList = resultSession.specialsList
            this.spePreList = preSession.specialsList
            this.preShow = this.preSession.sessionCode!='' ? true :false
            this.resultShow = (this.preSession.sessionCode=='' && this.resultSession.sessionCode!='') ? true : false
            this.moreLink = this.preShow ? '/preauction?status=0&page=1&evaluation_price=&advancedSeach=&start_time=&end_time=&rmbPriceStart=&rmbPriceEnd=&organ_code='+this.$route.params.id+'&citys=&organName='+this.organName+'&item=&is_total=1&keyword=' : '/result?status=1&page=1&ord=6&evaluation_price=&advancedSeach=&start_time=&end_time=&rmbPriceStart=&rmbPriceEnd=&organ_code='+this.$route.params.id+'&citys=&organName='+this.organName+'&item=&is_total=1&keyword='
        },
        gotoLogin:function () {
            window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
        }
    },
    components:{
        emptyPage
    }
}
</script>

<style scoped lang="scss">
.juhL-tab-con {
    margin-top: 24px;
    font-size: 12px;
    font-family: SimSun;
}
.juhL-tab-ul {
    height: 28px;
    line-height: 28px;
    border-bottom: #488ad4 2px solid;
}
.juhL-tab-li {
    width: 90px;
    float: left;
    text-align: center;
    font-weight: bold;
    color: #0c57b2;
    cursor: pointer;
    font-size: 12px;
    font-family: SimSun;
}
.juhL-more {
    float: right;
    padding-right: 10px;
    a:hover{text-decoration: underline;color:#09c}
}
.curr {
    background: #478bd4;
    color: #ffffff;
}
.juhL-tab-area {
    border: #e6e6e6 1px solid;
    border-top: none;
    .juhL-info a{color:#000;font-size: 12px;word-break:break-all;overflow: hidden;text-overflow: ellipsis;max-height: 36px;display:-webkit-box;display:-moz-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}
    .juhL-info a:hover{text-decoration: underline;color:#09c}
}
.juhL-tab-hd {
    line-height: 24px;
    padding: 0px 0px 25px 19px;
}
.juhL-sub-tit {
    height: 34px;
    padding-left: 10px;
    line-height: 34px;
    color: #000;
    font-size: 14px;
    margin: 0px 9px;
    background: #f3f3f3;
    border-bottom: #dcdcdc 1px solid;
}
.juhL-session {
    width: 582px;
    margin-left: 9px;
    padding-bottom: 24px;
    overflow: hidden;
}
.juhL-result {
    width: 582px;
    padding-bottom: 17px;
    overflow: hidden;
}
.juhL-tab-hd h1 {
    padding: 15px 0px 10px;
}
.juhL-tab-hd p {
    font-size: 14px;
}
.juhL-tab-hd span {
    color: #999999;
}
.juhL-session {
    width: 582px;
    margin-left: 9px;
    padding-bottom: 24px;
    overflow: hidden;
}
.session-ul {
    width: 612px;
    margin-left: 10px;
}
.juhL-search {
    display: block;
    float: left;
    padding-left: 68px;
}
.juhL-search label {
    display: block;
    float: left;
    color: #000;
    font-size: 14px;
}
.juhL-txt {
    display: block;
    float: left;
    width: 53px;
    height: 20px;
    border: #d2d2d4 1px solid;
    margin: 6px 10px 0px;
}
.juhL-btn {
    display: block;
    float: left;
    width: 40px;
    height: 22px;
    text-indent: -999999px;
    margin-top: 6px;
    border: #d2d2d4 1px solid;
    background: url(../../../assets/imgs/old/juhLBtn.png) no-repeat left top;
}
.juhL-result {
    width: 582px;
    padding-bottom: 17px;
    overflow: hidden;
}
.juhL-result-ul {
    padding-top: 2px;
    margin-left: 9px;
    width: 614px;
}
.juhL-result-ul li {
    width: 277px;
    float: left;
    margin: 18px 14px 0px 0px;
}
.juhL-link {
    width: 125px;
    height: 125px;
    margin-bottom: 8px;
    text-align: center;
    float: left;
    background: #ffffff;
    border: #f1f1f1 1px solid;
    display: table-cell;
    vertical-align: middle;
}
.juhL-link b {
    width: 125px;
    height: 125px;
    display:flex;
    img{width: 100%;height:100%;object-fit: contain}
}
.juhL-info {
    width: 130px;
    height: 127px;
    margin-bottom: 8px;
    margin-left: 10px;
    float: left;
    line-height: 18px;
    color: #333333;
    dt{font-weight: bold;
        span{margin-right: 3px;}
        .flagLabel{height:20px;margin:5px 0;}
    }
    .textGray {
        color: #999999;
    }
    .textGray:hover {
        color: #09c;
        text-decoration: underline;
    }
}
.juhL-de {
    clear: both;
    padding-left: 19px;
    line-height: 19px;
    color: #353535;
    background: url(../../../assets/imgs/old/zoom.png) no-repeat left center;
}
.juhL-prepare {
    line-height: 26px;
}
.juhL-tit {
    height: 34px;
    margin-top: 10px;
    padding-left: 15px;
    line-height: 34px;
    font-size: 14px;
    color: #ffffff;
    background: #488ad4;
    font-weight: bold;
}
.juhL-prepare h1 {
    padding: 14px 0px 8px 10px;
    font-weight: bold;
}
.juhL-prepare p {
    padding-left: 10px;
    font-size: 14px;
    color: #333333;
    span{color:#999999;}
}
.session-ul {
    width: 612px;
    margin-left: 10px;
    overflow: hidden;
    .session-item {
        width: 268px;
        margin-right: 30px;
        float: left;
        line-height: 26px;
        color: #323232;
        .flag{display:inline-block;
            img{margin-right: 8px;}
        }
        h1{
            padding: 13px 0px 6px;
            font-size: 12px;
        }
        p{font-size: 12px;}
        .view-works {
            padding-left: 19px;
            color: #353535;
            background: url(../../../assets/imgs/old/zoom.png) no-repeat left center;
        }
    }
    .session-item:nth-child(2n){
        margin-right: 0;
    }
}
</style>